"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stepsBetween = exports.stepsAtMost = exports.stepsAtLeast = exports.isStepAfter = exports.isStepBefore = exports.isStepAtMost = exports.isStepAtLeast = exports.compareProjectSteps = exports.projectStepRank = exports.PROJECT_STEP_ORDER = void 0;
const steps_1 = require("./steps");
/**
 * Canonical chronological order of project steps. A project progresses along
 * this order; terminal branches (REFUSED/ABANDONED) are placed at their
 * earliest possible occurrence.
 *
 * Use the helpers below to compare two steps — do NOT rely on declaration
 * order or on string comparison.
 *
 * Moved from `frontend/src/utils/projectSteps.ts` as part of feature 240 so
 * both backend and frontend can share the ordering.
 */
exports.PROJECT_STEP_ORDER = [
    steps_1.ProjectStep.PROJECT_INITIALIZED,
    steps_1.ProjectStep.PROJECT_REQUESTED,
    steps_1.ProjectStep.PROJECT_REFUSED,
    steps_1.ProjectStep.PROJECT_ACCEPTED,
    steps_1.ProjectStep.PROJECT_ORDERED,
    steps_1.ProjectStep.PROJECT_PAIED,
    steps_1.ProjectStep.PROJECT_IN_PROGRESS,
    steps_1.ProjectStep.PROJECT_FILE_COMPLETED,
    steps_1.ProjectStep.PROJECT_FILE_SENT,
    steps_1.ProjectStep.PROJECT_FILE_SUBMITTED,
    steps_1.ProjectStep.PROJECT_FILE_REFUSED,
    steps_1.ProjectStep.PROJECT_ABANDONED,
    steps_1.ProjectStep.PROJECT_COMPLETED,
];
const RANK = new Map(exports.PROJECT_STEP_ORDER.map((s, i) => [s, i]));
const projectStepRank = (step) => {
    const r = RANK.get(step);
    if (r === undefined) {
        throw new Error(`Unknown project step: ${step}`);
    }
    return r;
};
exports.projectStepRank = projectStepRank;
const compareProjectSteps = (a, b) => (0, exports.projectStepRank)(a) - (0, exports.projectStepRank)(b);
exports.compareProjectSteps = compareProjectSteps;
const isStepAtLeast = (step, threshold) => (0, exports.projectStepRank)(step) >= (0, exports.projectStepRank)(threshold);
exports.isStepAtLeast = isStepAtLeast;
const isStepAtMost = (step, threshold) => (0, exports.projectStepRank)(step) <= (0, exports.projectStepRank)(threshold);
exports.isStepAtMost = isStepAtMost;
const isStepBefore = (step, threshold) => (0, exports.projectStepRank)(step) < (0, exports.projectStepRank)(threshold);
exports.isStepBefore = isStepBefore;
const isStepAfter = (step, threshold) => (0, exports.projectStepRank)(step) > (0, exports.projectStepRank)(threshold);
exports.isStepAfter = isStepAfter;
const stepsAtLeast = (threshold) => exports.PROJECT_STEP_ORDER.filter((s) => (0, exports.isStepAtLeast)(s, threshold));
exports.stepsAtLeast = stepsAtLeast;
const stepsAtMost = (threshold) => exports.PROJECT_STEP_ORDER.filter((s) => (0, exports.isStepAtMost)(s, threshold));
exports.stepsAtMost = stepsAtMost;
const stepsBetween = (fromInclusive, toInclusive) => exports.PROJECT_STEP_ORDER.filter((s) => (0, exports.isStepAtLeast)(s, fromInclusive) && (0, exports.isStepAtMost)(s, toInclusive));
exports.stepsBetween = stepsBetween;
//# sourceMappingURL=order.js.map